import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import Layout from '../views/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('../views/Products.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'users/:id',
        name: 'UserDetails',
        component: () => import('../views/UserDetails.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'review-center',
        name: 'ReviewCenter',
        component: () => import('../views/ReviewCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'product-review-center',
        name: 'ProductReviewCenter',
        component: () => import('../views/ProductReviewCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'message-center',
        name: 'MessageCenter',
        component: () => import('../views/MessageCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'order-center',
        name: 'OrderCenter',
        component: () => import('../views/OrderCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders-to-deliver',
        name: 'OrdersToDeliver',
        component: () => import('../views/OrderCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders-delivered',
        name: 'OrdersDelivered',
        component: () => import('../views/OrderCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'distribution-center',
        name: 'DistributionCenter',
        component: () => import('../views/DistributionCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'member-review',
        name: 'MemberReview',
        component: () => import('../views/MemberReview.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'content/articles',
        name: 'ArticleManager',
        component: () => import('../views/ArticleManager.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'article-review',
        name: 'ArticleReview',
        component: () => import('../views/ArticleReview.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters.isAuthenticated
  
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
